import { Button, makeStyles, tokens } from '@fluentui/react-components';
import { ChevronLeftRegular } from '@fluentui/react-icons';

const useStyles = makeStyles({
  root: {
    alignSelf: 'flex-start',
    color: tokens.colorBrandForeground1,
    fontSize: '0.75rem',
    fontWeight: tokens.fontWeightSemibold,
    gap: tokens.spacingHorizontalXS,
    padding: 0,
  },
  icon: {
    width: '1.5rem',
    height: '1.5rem',
  },
});

export type BackLinkProps = {
  label?: string;
  onClick: () => void;
};

export function BackLink({ label = 'Back to Menu', onClick }: BackLinkProps) {
  const styles = useStyles();

  return (
    <Button className={styles.root} appearance="subtle" onClick={onClick}>
      <ChevronLeftRegular className={styles.icon} aria-hidden="true" />
      {label}
    </Button>
  );
}
